import ObserverTopIndicator from '@/domain/scene/indicators/observer/ObserverTopIndicator.js'
import ObserverTopIndicatorLine from '@/domain/scene/indicators/observer/lines/ObserverTopIndicatorLine.js'
import InTrainObserverTopIndicatorLine from '@/domain/scene/indicators/observer/lines/InTrainObserverTopIndicatorLine.js'

import ObserverBottomIndicator from '@/domain/scene/indicators/observer/ObserverBottomIndicator.js'
import ObserverBottomIndicatorLine from '@/domain/scene/indicators/observer/lines/ObserverBottomIndicatorLine.js'
import InTrainObserverBottomIndicatorLine from '@/domain/scene/indicators/observer/lines/InTrainObserverBottomIndicatorLine.js'

import PlatformLeftIndicator from '@/domain/scene/indicators/platform/PlatformLeftIndicator.js'
import PlatformMiddleIndicator from '@/domain/scene/indicators/platform/PlatformMiddleIndicator.js'
import PlatformRightIndicator from '@/domain/scene/indicators/platform/PlatformRightIndicator.js'

import TrainLeftIndicator from '@/domain/scene/indicators/train/TrainLeftIndicator.js'
import TrainMiddleIndicator from '@/domain/scene/indicators/train/TrainMiddleIndicator.js'
import TrainRightIndicator from '@/domain/scene/indicators/train/TrainRightIndicator.js'

export default class Indicators {
  constructor () {
    this.observer_top_indicator = new ObserverTopIndicator()
    this.observer_top_line = new ObserverTopIndicatorLine()
    this.in_train_observer_top_line = new InTrainObserverTopIndicatorLine()
    this.observer_bottom_indicator = new ObserverBottomIndicator()
    this.observer_bottom_line = new ObserverBottomIndicatorLine()
    this.in_train_observer_bottom_line = new InTrainObserverBottomIndicatorLine()

    this.platform_left_indicator = new PlatformLeftIndicator()
    this.platform_middle_indicator = new PlatformMiddleIndicator()
    this.platform_right_indicator = new PlatformRightIndicator()

    this.train_left_indicator = new TrainLeftIndicator()
    this.train_middle_indicator = new TrainMiddleIndicator()
    this.train_right_indicator = new TrainRightIndicator()
  }

  setOnScene (sceneWidth, sceneHeight, isInTrain, speedC) {
    this.observer_top_indicator.setOnScene(sceneWidth, sceneHeight, null, '')
    this.observer_top_line.setOnScene(sceneWidth, sceneHeight)
    this.in_train_observer_top_line.setOnScene(sceneWidth, sceneHeight)
    this.observer_bottom_indicator.setOnScene(sceneWidth, sceneHeight, null, '')
    this.observer_bottom_line.setOnScene(sceneWidth, sceneHeight)
    this.in_train_observer_bottom_line.setOnScene(sceneWidth, sceneHeight)

    if (isInTrain) {
      this.platform_left_indicator.setOnScene(sceneWidth, sceneHeight, speedC, '')
      this.platform_middle_indicator.setOnScene(sceneWidth, sceneHeight, speedC, '')
      this.platform_right_indicator.setOnScene(sceneWidth, sceneHeight, speedC, '')

      this.train_left_indicator.setOnScene(sceneWidth, sceneHeight, null, '')
      this.train_middle_indicator.setOnScene(sceneWidth, sceneHeight, null, '')
      this.train_right_indicator.setOnScene(sceneWidth, sceneHeight, null, '')
    } else {
      this.platform_left_indicator.setOnScene(sceneWidth, sceneHeight, null, '')
      this.platform_middle_indicator.setOnScene(sceneWidth, sceneHeight, null, '')
      this.platform_right_indicator.setOnScene(sceneWidth, sceneHeight, null, '')

      this.train_left_indicator.setOnScene(sceneWidth, sceneHeight, speedC, '')
      this.train_middle_indicator.setOnScene(sceneWidth, sceneHeight, speedC, '')
      this.train_right_indicator.setOnScene(sceneWidth, sceneHeight, speedC, '')
    }
  }

  setValues (isObserverInTrain, observerPosM, oppositeObjPosM, isRelativistic, speedValue) {
    this.platform_left_indicator.setValue(isObserverInTrain, oppositeObjPosM, isRelativistic, speedValue)
    this.platform_middle_indicator.setValue(isObserverInTrain, oppositeObjPosM, isRelativistic, speedValue)
    this.platform_right_indicator.setValue(isObserverInTrain, oppositeObjPosM, isRelativistic, speedValue)

    this.train_left_indicator.setValue(isObserverInTrain, oppositeObjPosM, isRelativistic, speedValue)
    this.train_middle_indicator.setValue(isObserverInTrain, oppositeObjPosM, isRelativistic, speedValue)
    this.train_right_indicator.setValue(isObserverInTrain, oppositeObjPosM, isRelativistic, speedValue)

    this.observer_top_indicator.setValue(isObserverInTrain, observerPosM, oppositeObjPosM, isRelativistic, speedValue)
    this.observer_bottom_indicator.setValue(isObserverInTrain, observerPosM, oppositeObjPosM, isRelativistic, speedValue)
  }
}
